import axios from "../utils/axios";

// ==========================================
// Admin Exports (Backend Sprint 14.2)
//
// Each module exposes its own POST /admin/{module}/export endpoint
// that accepts a `filters` payload, queues a job, and returns 202
// with `{ job_id, status_url, download_url: null }`. Status is
// polled via GET /admin/exports/{id} until completed/failed.
// ==========================================

const TYPE_TO_CREATE_PATH = {
    orders:    "/admin/orders/export",
    customers: "/admin/customers/export",
    inventory: "/admin/inventory/export",
    revenue:   "/admin/reports/revenue/export",
};

export const createExport = async (type, filters = {}) => {
    const path = TYPE_TO_CREATE_PATH[type];
    if (!path) throw new Error(`Unknown export type "${type}"`);
    const response = await axios.post(path, { filters });
    return response.data;
};

export const getExportStatus = async (id) => {
    const response = await axios.get(`/admin/exports/${id}`);
    return response.data;
};

export const downloadExport = async (id) => {
    const response = await axios.get(`/admin/exports/${id}/download`, {
        responseType: "blob",
    });
    return response;
};
